var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vuse-content-wrapper"},[(_vm.hasAccess('dashboard'))?_c('div',[_c('vuse-section-definition',{attrs:{"title":`Dashboard`,"icon":"mdi-view-dashboard"}}),_c('Announcement'),_c('DailyTimeclocks'),_c('DailySchedulesGrid',{staticClass:"mt-2"})],1):_c('NoPermission')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }